import React, { useState, useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import CheckOut from '../Interface/Sales/CheckOut';
import EventFormXV from '../Interface/Events/EventFormXV';
import EventFormBoda from '../Interface/Events/EventFormBoda';
import EventFormBirthday from '../Interface/Events/EventFormBirthday';
import '../../Styles/Controllers/ReservationController.css';
import AdditionalServicesRe from '../Interface/Services/AdditionalServicesRe'

import { Box, Container, Avatar, Typography } from '@mui/material';

import { CircularProgress } from '@mui/material';
import HttpsIcon from '@mui/icons-material/Https';

import { message } from 'antd';

function parseNumber(str) {
  if (!str) return 0;
  return Number(str.toString().replace(/,/g, ''));
}

const safeParseFloat = (value, defaultValue = 0) => {
  if (typeof value === 'number') return value;
  if (typeof value === 'string') {
    const parsed = parseFloat(value.replace(/,/g, ''));
    return isNaN(parsed) ? defaultValue : parsed;
  }
  return defaultValue;
};

function ReservationController({ dressList, suitList, getDressListHandler, getSuitListHandler, employee }) {
  const [reservationStep, setReservationStep] = useState(0);
  const [formValues, setFormValues] = useState({});
  const [services, setServices] = useState([]);
  const [arrOfServiceTypes, setArrOfServiceTypes] = useState([]);
  const [selectedServices, setSelectedServices] = useState([]);
  const [selectedServicesTotal, setSelectedServicesTotal] = useState(null);
  const [eventsScheduledXV, setEventsScheduledXV] = useState([]);
  const [handleReqEventsError, setHandleReqEventsError] = useState('');
  const [dressReservations, setDressReservations] = useState([]);
  const [suitReservations, setSuitReservations] = useState([]);
  const [clients, setClients] = useState([]);
  const [emptyClients, setEmptyClients] = useState(false);
  const [permissionError, setPermissionError] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [messageApi, contextHolder] = message.useMessage();

  const childRef = useRef(null);
  const navigate = useNavigate();
  const location = useLocation();

  const checkPermissions = async () => {
    const token = localStorage.getItem('token');
    if (!token) {
      setPermissionError(true);
      return messageApi.error({
        content: 'No se encontró el token de autenticación. Por favor, vuelve a iniciar sesión.',
        duration: 5
      }).then(() => {
        navigate('/sign-in');
      });
    }
    setPermissionError(false);
    setIsLoading(true);
    try {
      const response = await fetch('https://dprincess-training.servehttp.com/users/check-modify-role-permissions', {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        }
      });
      if (response.status === 403) {
        messageApi.error('No tienes permisos para acceder a esta sección.');
        setPermissionError(true);
        throw new Error('No tienes permisos para acceder a esta sección.');
      }
    } catch (error) {
      messageApi.error(error.message || 'Error al verificar permisos.');
      throw error; // Re-throw to handle it in the calling function
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    checkPermissions();
  }, []);

  const getEvents = async () => {
    const token = localStorage.getItem('token');
    if (!token) {
      setPermissionError(true);
      return messageApi.error({
        content: 'No se encontró el token de autenticación. Por favor, vuelve a iniciar sesión.',
        duration: 5
      }).then(() => {
        navigate('/sign-in');
      });
    }
    try {
      const response = await fetch('https://dprincess-training.servehttp.com/events', {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`
        },
      });
      const data = await response.json();
      if (response.status === 500) {
        return setHandleReqEventsError(data.errorMsg);
      }
      setEventsScheduledXV(data);
    } catch (error) {
      console.error('Error:', error);
      messageApi.error('Error al obtener los eventos programados.');
    }
  };

  const getDressReservations = async () => {
    const token = localStorage.getItem('token');
    if (!token) {
      setPermissionError(true);
      return messageApi.error({
        content: 'No se encontró el token de autenticación. Por favor, vuelve a iniciar sesión.',
        duration: 5
      }).then(() => {
        navigate('/sign-in');
      });
    }
    try {
      const response = await fetch('https://dprincess-training.servehttp.com/list-dress-reservations', {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`
        },
      });
      if (!response.ok) {
        const errorData = await response.json();
        console.error('Error:', errorData.message);
        return setHandleReqEventsError(errorData.message);
      }
      const data = await response.json();
      return setDressReservations(data);
    } catch (error) {
      console.error('Error:', error);
    }
  };

  const getSuitReservations = async () => {
    const token = localStorage.getItem('token');
    if (!token) {
      setPermissionError(true);
      return messageApi.error({
        content: 'No se encontró el token de autenticación. Por favor, vuelve a iniciar sesión.',
        duration: 5
      }).then(() => {
        navigate('/sign-in');
      });
    }
    try {
      const response = await fetch('https://dprincess-training.servehttp.com/list-suit-reservations', {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`
        },
      });
      if (!response.ok) {
        const errorData = await response.json();
        console.error('Error:', errorData.message);
        return setHandleReqEventsError(errorData.message);
      }
      const data = await response.json();
      return setSuitReservations(data);
    } catch (error) {
      console.error('Error:', error);
    }
  };

  const requestClients = async () => {
    const token = localStorage.getItem('token');
    if (!token) {
      setPermissionError(true);
      return messageApi.error({
        content: 'No se encontró el token de autenticación. Por favor, vuelve a iniciar sesión.',
        duration: 5
      }).then(() => {
        navigate('/sign-in');
      });
    }
    try {
      const response = await fetch('https://dprincess-training.servehttp.com/clients-list', {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });
      if (!response.ok) {
        throw new Error('Error al obtener los clientes');
      }
      const data = await response.json();
      if (data.length === 0) {
        return setEmptyClients(true);
      }
      return setClients(data);
    } catch (error) {
      console.error('Error:', error);
      messageApi.error('Error al obtener los clientes.');
    }
  };

  const handleSubmit = () => {
    if (childRef.current) {
      childRef.current.handleSubmit();
      if (formValues.length > 0) {
        setReservationStep(1);
      }
    }
  };

  const handleFormValues = (values) => {
    if (values) {
      return setFormValues(values);
    }
  }

  const addServiceType = (services, arrServiceTypes) => {
    let arrServiceType = arrServiceTypes
    services.forEach(service => {
      if (!arrServiceType.includes(service.serviceType)) {
        arrServiceType.push(service.serviceType);
      }
    });
    setArrOfServiceTypes(arrServiceType);
  };

  const depositChangeHandler = (deposit) => {
    deposit = safeParseFloat(deposit);
    let comboPrice = safeParseFloat(formValues.reservation.comboPrice);
    let paymentStatus = formValues.reservation.paymentStatus;
    if (deposit === comboPrice) {
      paymentStatus = 'pagado';
    }
    let cashFlow = formValues.reservationCashFlow;
    cashFlow.amount = deposit;
    setFormValues(prevFormValues => ({
      ...prevFormValues,
      reservation: {
        ...prevFormValues.reservation,
        paymentStatus: paymentStatus,
        deposit: deposit
      },
      reservationCashFlow: cashFlow
    }));
  };

  const handleServicesInvoice = (services) => {
    const servicesCashFlow = [];
    for (const service of services) {
      if (service.amountPaid && service.amountPaid > 0) {
        const cashFlow = {
          amount: service.amountPaid,
          description: "Pago por servicio " + service.serviceName,
          paymentMethod: 'efectivo',
          flowType: 'ingreso',
          serviceID: service.serviceID
        };
        servicesCashFlow.push(cashFlow);
      }
    }
    setFormValues(prevFormValues => ({
      ...prevFormValues,
      serviceCashFlow: servicesCashFlow
    }));
  };

  const handleChangePaymentMethod = (paymentMethod) => {
    setFormValues(prevFormValues => {
      const updatedServiceCashFlow = Array.isArray(prevFormValues.serviceCashFlow)
        ? prevFormValues.serviceCashFlow.map(cashFlowItem => ({
          ...cashFlowItem,
          paymentMethod: paymentMethod
        }))
        : [];

      return {
        ...prevFormValues,
        serviceCashFlow: updatedServiceCashFlow
      };
    });
  }

  const updateSelectedServices = (allSelectedServices) => {
    setSelectedServices(allSelectedServices);
    const formValuesCopy = { ...formValues };
    formValuesCopy.selectedServices = allSelectedServices;
    setFormValues(formValuesCopy);
  };

  const additionalDress = (dress) => {
    if (dress) {
      const dressArr = Array.isArray(dress) ? dress : [dress];
      const formValuesCopy = { ...formValues };
      if (formValuesCopy.additionalDresses && Array.isArray(formValuesCopy.additionalDresses)) {
        formValuesCopy.additionalDresses = [...formValuesCopy.additionalDresses, ...dressArr];
      }
      else {
        formValuesCopy.additionalDresses = dressArr;
      }
      setFormValues(formValuesCopy);
    }
  };

  const additionalSuit = (suit) => {
    if (suit) {
      const suitArr = Array.isArray(suit) ? suit : [suit];
      const formValuesCopy = { ...formValues };
      if (formValuesCopy.additionalSuits && Array.isArray(formValuesCopy.additionalSuits)) {
        formValuesCopy.additionalSuits = [...formValuesCopy.additionalSuits, ...suitArr];
      }
      else {
        formValuesCopy.additionalSuits = suitArr;
      }
      setFormValues(formValuesCopy);
    }
  };

  const deleteDressWithID = (dressID) => {
    const formValuesCopy = { ...formValues };
    if (formValuesCopy.additionalDresses) {
      const updatedDresses = formValuesCopy.additionalDresses.filter(dress => dress.dressID !== dressID);
      formValuesCopy.additionalDresses = updatedDresses;
      setFormValues(formValuesCopy);
    }
  };

  const deleteSuitWithID = (suitID) => {
    const formValuesCopy = { ...formValues };
    if (formValuesCopy.additionalSuits) {
      const updatedSuits = formValuesCopy.additionalSuits.filter(suit => suit.suitID !== suitID);
      formValuesCopy.additionalSuits = updatedSuits;
      setFormValues(formValuesCopy);
    }
  };

  const previousStepHandler = () => {
    if (reservationStep > 0) {
      return setReservationStep(reservationStep - 1);
    }
  };
  const nextStepHandler = () => {
    if (reservationStep === 0) {
      handleSubmit()
    }
    if (reservationStep < 2 && Object.keys(formValues).length > 0) {
      return setReservationStep(reservationStep + 1);
    }
  };
  const handleSelectedServicesTotal = (total) => {
    formValues.reservation.servicesTotal = total;
    setSelectedServicesTotal(total);
  };

  const requestServices = async () => {
    const token = localStorage.getItem('token');
    if (!token) {
      setPermissionError(true);
      return messageApi.error({
        content: 'No estás autenticado. Por favor, inicia sesión.',
        duration: 5
      }).then(() => {
        navigate('/sign-in');
      });
    }
    try {
      const response = await fetch('https://dprincess-training.servehttp.com/services-list', {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`
        },
      });
      if (response.status === 401) {
        localStorage.removeItem('token');
        return navigate('/sign-in');
      }
      const data = await response.json();
      return setServices(data);
    } catch (error) {
      console.error('Error:', error);
      messageApi.error('Error al obtener la lista de servicios.');
    }
  };
  useEffect(() => {
    if (services.length === 0) {
      requestServices();
    }
  }, []);
  useEffect(() => {
    if (services.length > 0) {
      addServiceType(services, arrOfServiceTypes);
    }
  }, [services]);

  useEffect(() => {
    if (formValues.length > 0 && reservationStep === 0) {
      setReservationStep(1);
    }
  }, [formValues]);

  useEffect(() => {
    if (selectedServicesTotal) {
      setFormValues(prevFormValues => ({
        ...prevFormValues,
        reservation: {
          ...prevFormValues.reservation,
          selectedServicesTotal: selectedServicesTotal
        }
      }))
    }
  }, [selectedServicesTotal]);

  useEffect(() => {
    getEvents();
  }, []);
  useEffect(() => {
    getDressReservations();
  }, []);
  useEffect(() => {
    getSuitReservations();
  }, []);
  useEffect(() => {
    requestClients();
  }, []);
  useEffect(() => {
    if (clients.length === 0 && emptyClients === false) {
      requestClients();
    }
  }, [clients]);

  if (isLoading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
        <CircularProgress />
      </Box>
    );
  }

  if (permissionError) {
    return (
      <Container maxWidth="sm" sx={{ py: 8 }}>
        {contextHolder}
        <Box sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '60vh',
          gap: 2
        }}>
          <Avatar sx={{ bgcolor: '#f44336', width: 64, height: 64 }}>
            {/* Icono de candado para indicar acceso restringido */}
            <HttpsIcon sx={{ fontSize: 40 }} />
          </Avatar>
          <Typography variant="h5" sx={{ color: '#f44336', fontWeight: 700 }}>
            No tienes permiso para acceder a esta sección
          </Typography>
          <Typography variant="body1" sx={{ color: '#666', textAlign: 'center' }}>
            Esta información solo está disponible para usuarios con permisos de administrador.
          </Typography>
        </Box>
      </Container>
    );
  };

  return (
    <div className='reservation-main-container' style={{ display: 'flex', flexDirection: 'column', width: '100%', height: '100%' }}>
      <div className='reservation-container'>
        {
          reservationStep === 0 && location.pathname === `/events/reservation-form-xv` ?
            <EventFormXV handleFormValues={handleFormValues} formValues={formValues} ref={childRef} nextStepHandler={nextStepHandler} reservationStep={reservationStep}
              clients={clients} dressList={dressList} getDressListHandler={getDressListHandler} eventsScheduledXV={eventsScheduledXV} dressReservations={dressReservations}
              requestClients={requestClients}
            />
            : reservationStep === 0 && location.pathname === `/events/reservation-form-boda` ?
              <EventFormBoda handleFormValues={handleFormValues} formValues={formValues} ref={childRef} nextStepHandler={nextStepHandler} reservationStep={reservationStep} eventsScheduledXV={eventsScheduledXV} requestClients={requestClients}
                clients={clients} dressList={dressList} getDressListHandler={getDressListHandler} suitList={suitList} getSuitListHandler={getSuitListHandler} dressReservations={dressReservations} suitReservations={suitReservations} />
              : reservationStep === 0 && location.pathname === `/events/reservation-form-birthday` ?
                <EventFormBirthday handleFormValues={handleFormValues} formValues={formValues} ref={childRef} nextStepHandler={nextStepHandler} reservationStep={reservationStep} clients={clients} 
                  requestClients={requestClients}
                />
                : null
        }
        {
          reservationStep === 1 && <AdditionalServicesRe reservation={formValues.reservation} previousStepHandler={previousStepHandler} selectedServices={selectedServices}
            nextStepHandler={nextStepHandler} reservationStep={reservationStep} updateSelectedServices={updateSelectedServices} services={services} arrOfServiceTypes={arrOfServiceTypes}
            depositChangeHandler={depositChangeHandler} dressList={dressList} additionalDress={additionalDress} handleServicesInvoice={handleServicesInvoice} suitList={suitList}
            dressReservations={dressReservations} eventDate={formValues.event} deleteDressWithID={deleteDressWithID} newDressReservation={formValues.additionalDresses} 
            additionalSuit={additionalSuit} newSuitReservation={formValues.additionalSuits} suitReservations={suitReservations} event={formValues.event} deleteSuitWithID={deleteSuitWithID}
          />
        }
        {
          reservationStep === 2 && <CheckOut formValues={formValues} selectedServices={selectedServices} previousStepHandler={previousStepHandler}
            handleSelectedServicesTotal={handleSelectedServicesTotal} employee={employee} handleChangePaymentMethod={handleChangePaymentMethod} />
        }
      </div>
    </div>
  )
}

export default ReservationController